import React from 'react';
import LayerAggregate from './LayerAggregate';
import SummarizeInline from '../SummarizeInline';

class InlineAggregateLayer extends LayerAggregate {
  constructor(
    keys = [],
    functions = [],
    extraColumns = [],
    pks = [],
    useDatetimeColumnAsDatetimeColumnAggregate = true,
  ) {
    super(
      keys,
      functions,
      extraColumns,
      pks,
      useDatetimeColumnAsDatetimeColumnAggregate,
    );
  }

  editMode(columns, aliases, onUpdateLayer, step) {
    const pks = columns.filter((c) => c.isPk()).map((c) => c.name());
    const setState = (delta) => {
      const updated = Object.assign(this.getState(), delta);

      onUpdateLayer(
        new InlineAggregateLayer(
          updated.groupBys,
          updated.metrics,
          updated.extraColumns,
          pks,
          step._useDatetimeColumnAsDatetimeColumnAggregate,
        ),
      );
    };
    return (
      <SummarizeInline
        state={this.getState()}
        setState={setState}
        columns={columns}
        aliases={aliases}
        currentLayer={this}
        onUpdateLayer={onUpdateLayer}
      />
    );
  }

  getState() {
    return {
      groupBys: this.keys(),
      metrics: this.functions(),
      extraColumns: this.extraColumns(),
    };
  }

  readonlyMode(onEditLayerClicked, aliases) {
    if (this.isTemplate()) {
      // happens when step is moved to inactive (and no values have been filled in)
      return (
        <SummarizeInline
          state={this.getState()}
          setState={() => null}
          columns={[]}
          aliases={{}}
          onUpdateLayer={() => null}
        />
      );
    }
    return this.buildContent(onEditLayerClicked, aliases);
  }
}

export default InlineAggregateLayer;
